// extracted by mini-css-extract-plugin
export default {"dropdown__icon_flipped":"DropdownInput-styles__dropdown__icon_flipped__ZNlON"};